export default "__VITE_ASSET__CHGEHb5f__"